import type { CSSProperties } from 'react';
import type { LocalizedImage } from '@segmently/schema-models/v2';

const DEFAULT_LIST_IMAGE_SIZE = 48;

/**
 * List rows historically used a fixed 48x48 image slot. Preserve that as the
 * missing-dimensions fallback, but let authored image width/height size both
 * the slot and the Image instead of forcing fillContainer to erase them.
 */
export function getListImagePresentation(image: LocalizedImage | undefined): {
  assetStyle: CSSProperties;
  fillContainer: boolean;
} {
  const width = image?.appearance?.dimensions?.width;
  const height = image?.appearance?.dimensions?.height;
  const hasAuthoredDimensions =
    typeof width === 'number' || typeof height === 'number';

  return {
    assetStyle: {
      width: typeof width === 'number' ? width : DEFAULT_LIST_IMAGE_SIZE,
      height: typeof height === 'number' ? height : DEFAULT_LIST_IMAGE_SIZE,
    },
    fillContainer: !hasAuthoredDimensions,
  };
}
